import { useEffect, useState } from "react";
import { Loader2, Trash2, Mail, MailOpen } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function MessagesTab() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/messages").then((r) => setMessages(r.data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    try {
      await api.delete(`/admin/messages/${id}`);
      setMessages((m) => m.filter((x) => x.id !== id));
      toast.success("Message deleted");
    } catch { toast.error("Failed to delete"); }
  };

  const when = (iso) => { try { return new Date(iso).toLocaleString(); } catch { return iso; } };

  if (loading) return <div className="py-16 flex justify-center" data-testid="messages-loading"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;

  return (
    <div className="space-y-4" data-testid="messages-tab">
      <div className="flex items-center justify-between">
        <h2 className="font-display text-2xl">Messages</h2>
        <span className="font-mono-label text-[11px] text-muted-foreground">{messages.length} total</span>
      </div>

      {messages.length === 0 ? (
        <div className="border border-dashed border-border rounded-md py-16 text-center text-sm text-muted-foreground" data-testid="messages-empty">
          <MailOpen className="w-8 h-8 mx-auto mb-3 opacity-50" />
          No messages yet. Submissions from your Contact page will appear here.
        </div>
      ) : (
        <div className="space-y-3">
          {messages.map((m) => (
            <div key={m.id} className="bg-card border border-border p-5" data-testid={`message-${m.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <Mail className="w-4 h-4 text-primary shrink-0" />
                    <span className="font-medium">{m.name || "Anonymous"}</span>
                    {m.email && (
                      <a href={`mailto:${m.email}`} className="font-mono text-xs text-primary hover:underline break-all">{m.email}</a>
                    )}
                  </div>
                  {m.subject && <p className="font-mono-label text-[11px] text-muted-foreground mt-2">RE: {m.subject}</p>}
                </div>
                <div className="flex items-center gap-3 shrink-0">
                  <span className="font-mono text-[10px] text-muted-foreground whitespace-nowrap">{when(m.created_at)}</span>
                  <button onClick={() => remove(m.id)} data-testid={`message-delete-${m.id}`} className="text-muted-foreground hover:text-destructive transition-colors">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
              <p className="text-sm text-muted-foreground mt-3 whitespace-pre-wrap leading-relaxed">{m.message}</p>
              {m.email && (
                <a href={`mailto:${m.email}?subject=${encodeURIComponent("Re: " + (m.subject || "Your message to NC Mycology"))}`}
                  className="inline-block mt-3 font-mono-label text-[11px] text-primary hover:underline">Reply by email →</a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
